import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, ErrorMsg } from "@onegovbugs/onegov-react-components";
import { hasAnyValue, validate } from "../../../utils/Validation";
import styles from "./Location.module.scss";
import {
  storeLocationData,
  saveApplication
} from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";
import LocationList from "../../../components/floraFauna/locationData/LocationList";

const LocationDetail = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();
  const locationDetail = useSelector((state) => state.locationDetail);
  const [locationList, setLocationList] = useState(
    locationDetail && locationDetail.locationList
      ? locationDetail.locationList.map((on) => ({ ...on }))
      : []
  );
  
  const storeData = (finished) => {
    const locationRecord = {
      locationList,
      finished,
      step : 6
    };

    dispatch(storeLocationData(locationRecord));
  };

  //validaitons
  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({
    locationList: false,
  });

  const validators = [
    {
      fieldName: "locationList",
      fieldValue: locationList,
      isValid: hasAnyValue,
    },
  ];
  useEffect(() => {
    validate(validators, setErrors);
  }, [locationList]);

  const deleteActionHandler = (i) => {
    let values = [...locationList];
    values.splice(i, 1);
    setLocationList([...values]);
    const locationRecord = {
      locationList: values
    };
    dispatch(storeLocationData(locationRecord));
  };

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={`col-12`}>
          <p>
            You are required to provide details of the sites or locations where
            you intend to conduct your project. Click on the <b>'Add location data' </b>
            button and select a <b>'Tenure Type'</b>. New fields will then appear in which you can select specific locations of that tenure
             type. To select all values of a 'Tenure Type' make your selection from the <b>'Tenure Type'</b> field and
            leave all other fields blank.
          </p>
          <p>
            For work on National Parks and Wildlife Service estate, select <b>'NPWS Estate'</b> as the tenure type. In
            the <b>'Branch / Region / Area / Park'</b> field start typing the name of
            the <b>'Park'</b> and the auto search will display a list of values displayed in the format ‘Branch Region Area Park’. You
            are required to select a value from the list that <i>ends</i> with the park you’re applying to conduct your project in.
          </p>
          <p>
            If your project will be undertaken in all parks in an <b>Area</b> or all
            <b> Regions</b> in a <b>Branch</b>, select the option that <i>ends</i> with the relevant Branch, Region or Area. For example, 
            typing in 'Lane' will enable you to select 'Metropolitan Metro North East Lane Cove Lane Cove National Park'.
            If you propose to work in all parks within the Lane Cove Area, select 'Metropolitan Metro North East Lane Cove' instead. 
            This can also be done for Regions and Branches.
          </p>
          <p>
            Additional comments or descriptions can be added in the <b>'Other'</b> field for each entry you make.
          </p>
        </div>
        <br />
        <div className={"col-12"}>
          <LocationList
            props={props}
            locationList={locationList}
            deleteActionHandler={deleteActionHandler}
          />
        </div>
      </div>
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            secondary
            onClick={() => {
              props.history.push(`./location/detail`);
            }}
          >
            Add location data
          </Button>
        </div>
      </div>
      {errors.locationList && showErrors ? (
        <ErrorMsg type={"error"} description={"Please add location data."} />
      ) : null}
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                storeData(true);
                dispatch(
                  saveApplication("step6", () => {
                    props.history.push(`../../flora-fauna/dashboard`);
                  })
                );
                setShowErrors(false);
              } else {
                setShowErrors(true);
              }
            }}
          >
            Continue
          </Button>

          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveApplication("step6", () => {
                  props.history.push(`../../flora-fauna/dashboard`);
                })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <LocationDetail {...props} />);
